import Navigator, { NAVIGATOR_HEIGHT } from '../../components/Navigator';
import LoginBg from '../../assets/login-background.png';
import { Grid, Box, Button, Typography, Divider, Card, CardContent, CardMedia } from '@mui/material';
import {
  headerStyles,
  contentHeading,
  cardStyles,
  courseCard,
  cardSection1,
  cardSection2,
  cardSectionMain,
} from './styles';
import CourseImg from '../../assets/MainPage/card1.png';
import Card1 from '../../assets/MainPage/courseImg1.png';
import Card2 from '../../assets/MainPage/courseImg2.png';
import Card3 from '../../assets/MainPage/courseImg3.png';
import { useHistory } from 'react-router-dom';
import Copyright, { COPYRIGHT_HEIGHT } from '../../components/Copyright';
import React from 'react';
export const CourseDetailPage = () => {
  const history = useHistory();

  return (
    <main
      style={{
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: `url(${LoginBg}) no-repeat center center`,
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        position: 'inherit',
      }}
    >
      <Navigator />
      <div
        style={{
          display: 'flex',
          height: `calc(100% - ${NAVIGATOR_HEIGHT + COPYRIGHT_HEIGHT}px)`,
          width: '90%',
          flexDirection: 'column',
          paddingTop: '20px',
        }}
      >
        {/* Header Section */}
        <Box sx={headerStyles}>
          <Typography variant="h6" component="h2" sx={contentHeading}>
            Online training course
          </Typography>
          <Button variant="contained" startIcon={<i className="bi bi-arrow-return-left"></i>} onClick={() => { history.push('/main'); }} >
            Back
          </Button>
        </Box>

        {/* Content */}
        <Grid container columnSpacing={2} rowSpacing={2} pb={7}>
          <Grid item xs={12} sm={4} md={3} lg={3} xl={3}>
            <Card sx={cardStyles}>
              <CardMedia component="img" height="190" image={CourseImg} alt="green iguana" />
              <CardContent style={{ marginTop: '0px', paddingLeft: '8px' }}>
                <div className="cardTitle">
                  Module 1 Phishing
                  <br />
                  單元1 網絡釣魚
                </div>

                <Divider
                  orientation="horizontal"
                  sx={{ margin: '12px 0px 12px 0px', borderColor: 'rgb(128, 182, 224)' }}
                />

                <Typography variant="body2" color="text.secondary" className="timeText">
                  Time Estimate: 5-10mins <br />
                  時間估計: 5-10分鐘
                </Typography>

                <div className="cardContent">
                  Complete the following training component <br />
                  1. Basic Training <br />
                  2. Video Training <br />
                  3. Quiz
                </div>
                <div className="cardContent1">
                  完成以下訓練要求 <br />
                  1: 基礎訓練 <br />
                  2: 視頻訓練 <br />
                  3: 測驗
                </div>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={8} md={9} lg={9} xl={9}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Card sx={courseCard}>
                  <Grid container rowSpacing={2}>
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Box sx={cardSection1}>
                        <img src={Card1} alt="card1" />
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={12} md={8} lg={8} xl={8} sx={cardSectionMain}>
                      <Box sx={cardSection2}>
                        <div className="card-section2-main">
                          <Typography variant="h6" component="h2" color="#006EC2" className="card-section2-h">
                            Module 1.1 Fundamentals of Phishing
                            <span className="badge">Mandatory</span>
                          </Typography>
                        </div>
                        <div className="card-section2-desc">Time : 5 mins</div>
                        <div className="course-description">
                          Learning Objectives After you complete this module, you&lsquo;ll be able to understand: What is
                          phishing? Types of phishing. Impact of phishing. How to handle phishing attack at work?
                        </div>
                      </Box>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card sx={courseCard}>
                  <Grid container rowSpacing={2}>
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Box sx={cardSection1}>
                        <img src={Card2} alt="card2" />
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={12} md={8} lg={8} xl={8} sx={cardSectionMain}>
                      <Box sx={cardSection2}>
                        <div className="card-section2-main">
                          <Typography variant="h6" component="h2" color="#006EC2" className="card-section2-h">
                            單元1 網絡釣魚
                            <span className="badge">必修</span>
                          </Typography>
                        </div>
                        <div className="card-section2-desc">時間 : 5分鐘</div>
                        <div className="course-description">
                          學習目標 完成本單元後，您將能夠了解: 為什麼需要密碼? 密碼攻擊有哪些類型? 什麼是強密碼?
                          什麼是多因素身份驗證? 密碼處理的注意事項。
                        </div>
                      </Box>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card sx={courseCard}>
                  <Grid container rowSpacing={2}>
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Box sx={cardSection1}>
                        <img src={Card3} alt="card3" />
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={12} md={8} lg={8} xl={8} sx={cardSectionMain}>
                      <Box sx={cardSection2}>
                        <div className="card-section2-main">
                          <Typography variant="h6" component="h2" color="#006EC2" className="card-section2-h">
                            Module 1 Quiz
                            <span className="badge">Mandatory</span>
                          </Typography>
                        </div>
                        <div className="card-section2-desc">Time : 5 mins</div>
                        <div className="course-description">
                          Module 1 Quiz <br /> Phishing
                        </div>
                      </Box>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Copyright />
    </main>
  );
};

export default CourseDetailPage;
